import script from "./Principal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Principal.vue?vue&type=script&setup=true&lang=ts"

import "./Principal.vue?vue&type=style&index=0&id=835b9ffe&lang=css"

const __exports__ = script;

export default __exports__